import TenantNewTermSchoolClassCard from '../Common/TenantNewTermSchoolClassCard';

type Props = {
    tabActiveKey: string;
    hasTouchScreen: boolean;
};

const AdminSetting: React.FC<Props> = ({ hasTouchScreen, tabActiveKey }) => {
    return (
        <div className='container'>
            <TenantNewTermSchoolClassCard tabActiveKey={tabActiveKey} />
        </div>
    );
};

export default AdminSetting;
